module.exports = __webpack_public_path__ + "img/img_index_cha_02_2@2x.d2ce3bdc.png";